module.exports = __webpack_public_path__ + "img/77cfcfe5525d392a91457d5e35b0352c.cbbe35d1.svg";